<div>
    <div>
        <h1 class="margin-bottom">{{ 'home.sherpasPage.title' | translate }}</h1>
        <div>
            <div class="margin-top"><span class="progress-text">{{ 'home.sherpasPage.progress' | translate }}</span> <span class="together-text">{{ 'home.sherpasPage.together' | translate }}</span></div>
            <div class="margin-top">
                <div class="margin-top" [innerHTML]="'home.sherpasPage.p1' | translate"></div>
                <div class="margin-top">{{ 'home.sherpasPage.p2' | translate }}</div>
                <div class="margin-top margin-bottom">{{ 'home.sherpasPage.p3' | translate }}</div>
            </div>
        </div>
        <div>
            <div class="margin-bottom-xl tabs-container" >
                <app-in-page-tabs [withClick]="false" [showArrowIcons]="false" arrowDown [tabs]="tabs"/>
              </div>
        </div>
        <div class="image-container">
            <div *ngFor="let certification of certifications">
                <img [src]="'assets/images/' + certification.image + '.png'" alt="{{ certification.image }}"/>
            </div>
        </div>
    </div>  
    <app-sherpas-card-pagination [newItems$]="newItems$" [mainRepository]="mainRepository">
        <ng-template #card let-item>
            <app-sherpa-card (clickOnDetails)="goToUserDetails($event)" [user]="item"></app-sherpa-card>
        </ng-template>
    </app-sherpas-card-pagination>
</div>
